import React from 'react';
import { Box, Button, Paper, Typography, Divider } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { BRAND } from '../../config/brand';

// ============================================================================
// DEMO SÜRESİ DOLDU KİLİT EKRANI
// MainLayout, sunucunun hesapladığı demoExpired=true olduğunda içerik yerine
// bunu render eder. Backend zaten enabledModules=[] döndürdüğü için menüler de
// boştur; bu ekran kullanıcıya durumu açıklar (çıkış hariç erişim yok).
// ============================================================================

const DemoExpiredScreen: React.FC = () => {
  const { logout, demoUntil } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      navigate('/login');
    }
  };

  const formattedDate = demoUntil
    ? new Date(demoUntil).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })
    : null;

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 120px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: 480,
          width: '100%',
          p: { xs: 3, sm: 5 },
          textAlign: 'center',
          borderRadius: 3,
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            bgcolor: 'error.light',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2.5,
          }}
        >
          <LockOutlinedIcon sx={{ fontSize: 40, color: 'white' }} />
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          Demo Süreniz Doldu
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
          {formattedDate
            ? `Demo kullanım süreniz ${formattedDate} tarihinde sona erdi.`
            : 'Demo kullanım süreniz sona erdi.'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Verileriniz güvende — sistemi kullanmaya devam etmek için lütfen bizimle
          iletişime geçin, hesabınızı hemen aktifleştirelim.
        </Typography>

        <Divider sx={{ mb: 2.5 }} />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center', mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <PhoneIcon fontSize="small" color="primary" />
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {BRAND.contact.customerService}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <EmailIcon fontSize="small" color="primary" />
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {BRAND.contact.email}
            </Typography>
          </Box>
        </Box>

        <Button
          variant="outlined"
          color="inherit"
          startIcon={<LogoutIcon />}
          onClick={handleLogout}
          sx={{ textTransform: 'none' }}
        >
          Çıkış Yap
        </Button>
      </Paper>
    </Box>
  );
};

export default DemoExpiredScreen;
